import { Image, Text, TouchableOpacity, View } from 'react-native'
import { useSelector } from 'react-redux'
import { useState } from 'react'
import styles from '../styles'
import { CustomTextInput } from '../../sign_up/SignupScreen.main'
import { i18n } from '$localization/config.js'

const LOGIN_SCREEN_INPUT = 'login_screen_input'

export default function FormFields({
  hasUserEnteredEmail,
  email,
  setEmail,
  password,
  setPassword,
}) {
  const colorSettings = useSelector((state) => state.store.colorSettings)
  const [showPassword, setShowPassword] = useState(true)

  const shouldShowPasswordIcon = showPassword
    ? require('$assets/images/icon/eye-close/black.png')
    : require('$assets/images/icon/eye/black.png')
  const parentRefs = {
    emailInputRef: null,
    passwordInputRef: null,
  }

  const setParentRef = (key, ref) => {
    if (!key || !ref) return
    parentRefs[key] = ref
  }

  return (
    <View style={styles.formContainer}>
      <CustomTextInput
        setRef={(ref) => setParentRef('emailInputRef', ref)}
        nativeID={LOGIN_SCREEN_INPUT}
        colorSettings={colorSettings}
        label={i18n.t('email')?.default}
        keyboardType="email-address"
        disabled={hasUserEnteredEmail}
        onSubmitEditing={() => parentRefs.passwordInputRef.focus()}
        value={email}
        onChangeText={(value) => {
          setEmail(value)
        }}
      />
      <View style={styles.formFieldTextInputPasswordContainer}>
        <CustomTextInput
          containerStyle={{ flex: 1 }}
          inputStyle={[
            styles.formFieldTextInputField,
            styles.formFieldTextInputPassword,
            {
              color: colorSettings?.text_input_color_1 ?? 'black',
            },
          ]}
          setRef={(ref) => setParentRef('passwordInputRef', ref)}
          nativeID={LOGIN_SCREEN_INPUT}
          colorSettings={colorSettings}
          label={i18n.t('password')?.default}
          secureTextEntry={showPassword}
          value={password}
          onChangeText={(value) => {
            setPassword(value)
          }}
        />
        <View
          style={[
            styles.formFieldShowPasswordContainer,
            {
              borderBottomColor: colorSettings?.text_input_label_color_1,
            },
          ]}
        >
          <TouchableOpacity
            activeOpacity={0.8}
            onPress={() => setShowPassword(!showPassword)}
          >
            <Image
              style={styles.formFieldShowPasswordImage}
              source={shouldShowPasswordIcon}
            />
          </TouchableOpacity>
        </View>
      </View>
      <View style={styles.formFieldHelperTextContainer}>
        <Text
          style={[
            styles.formFieldPasswordHelperText,
            {
              color: colorSettings?.text_input_label_color_1,
            },
          ]}
        >
          {
            i18n.t(
              'minimum_of_8_characters_one_uppercase_letter_one_lowercase_letter_one_number'
            )?.default
          }
        </Text>
      </View>
    </View>
  )
}
